import { useAuth } from './useAuth';

/**
 * Hook to access the current user session
 */
export function useSession() {
  const { session, user, isAuthenticated, isLoading, refreshSession } = useAuth();

  return {
    session,
    user,
    isAuthenticated,
    isLoading,
    refreshSession,
  };
}

